interface Props {
  className?: string;
  icon?: string;
}

const Icon = ({ className, icon }: Props) => (
  // @ts-expect-error: class "does not exist on type"
  <raul-icon class={className} icon={icon || ''} />
);

export default Icon;
